import { render, staticRenderFns } from "./InvoiceOverview.vue?vue&type=template&id=19b0bd4e&"
import script from "./InvoiceOverview.vue?vue&type=script&lang=js&"
export * from "./InvoiceOverview.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceOverview.vue?vue&type=style&index=0&id=19b0bd4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports